export const monthSales = (state) => {
  if (state.data && state.data.thisMonthSales) {
    return state.data.thisMonthSales
  }
  return 0
}

export const monthSalesCount = (state) => {
  if (state.data && state.data.thisMonthSalesCount) {
    return state.data.thisMonthSalesCount
  }
  return 0
}

export const promedio = (state, getters) => {
  if (getters.monthSales && getters.monthSalesCount !== 0) {
    return getters.monthSales / getters.monthSalesCount
  }
  return 0
}

export const prevPeriodSales = (state) => {
  if (state.data && typeof state.data.prevPeriodSales !== 'undefined') {
    return state.data.prevPeriodSales
  }
  return 0
}

export const prevPeriodSalesCount = (state) => {
  if (state.data && typeof state.data.prevPeriodSalesCount !== 'undefined') {
    return state.data.prevPeriodSalesCount
  }
  return 0
}

// Variacion porcentual de ventas vs periodo anterior. null = sin base de comparacion.
export const salesGrowth = (state, getters) => {
  const prev = getters.prevPeriodSales
  if (!prev || prev === 0) {
    return null
  }
  return ((getters.monthSales - prev) / prev) * 100
}

export const salesCountGrowth = (state, getters) => {
  const prev = getters.prevPeriodSalesCount
  if (!prev || prev === 0) {
    return null
  }
  return ((getters.monthSalesCount - prev) / prev) * 100
}

export const creditNotesTotal = (state) => {
  if (state.data && state.data.creditNotesTotal) {
    return state.data.creditNotesTotal
  }
  return 0
}

export const creditNotesCount = (state) => {
  if (state.data && state.data.creditNotesCount) {
    return state.data.creditNotesCount
  }
  return 0
}

export const totalReceivable = (state) => {
  if (state.data && state.data.totalReceivable) {
    return state.data.totalReceivable
  }
  return 0
}

export const paymentMethods = (state) => {
  if (state.data && state.data.paymentMethods) {
    return state.data.paymentMethods
  }
  return []
}

export const lowStockProducts = (state) => {
  if (state.data && state.data.lowStockProducts) {
    return state.data.lowStockProducts
  }
  return []
}

export const lowStockCount = (state) => {
  if (state.data && state.data.lowStockCount) {
    return state.data.lowStockCount
  }
  return 0
}

export const canFilterBranch = (state) => !!(state.data && state.data.canFilterBranch)

export const branchoffices = (state) => {
  if (state.data && state.data.branchoffices) {
    return state.data.branchoffices
  }
  return []
}

export const lastFiveSales = (state) => {
  if (state.data && state.data.lastFiveSales) {
    return state.data.lastFiveSales
  }
  return []
}

export const topProductsSales = (state) => {
  if (state.data && state.data.topProductsSales) {
    return state.data.topProductsSales
  }
  return []
}

export const topProduct = (state, getters) => getters.topProductsSales[0] || null

export const topDebtsClients = (state) => {
  if (state.data && state.data.topDebtsClients) {
    return Object.values(state.data.topDebtsClients)
  }
  return []
}

export const chartData = (state) => (state.data && state.data.chartData) || []
export const chartLabels = (state) => (state.data && state.data.chartLabels) || []
export const graphOptions = (state) => (state.data && state.data.graphOptions) || {}
